import * as React from "react";

// plugin imports

// utils imports
import FetchData from "../utils/fetchData";

// svg imports

export const RouteContext = React.createContext({
	location: undefined,
});

const defaultValues = {
	menuData: undefined,
	menuDataError: false,
};

export const MenuDataContext = React.createContext(defaultValues);

export const MenuDataProvider = ({ children }) => {
	const [menuData, setMenuData] = React.useState(undefined);
	const [menuDataError, setMenuDataError] = React.useState(false);

	const { location } = React.useContext(RouteContext);
	// console.log("location: " + location.pathname);

	const APIKey = "AIzaSyDDj79TZ3ejphOBlMPckITko9sFR4I2XsQ";
	const spreadsheetId = "1If4tzLtBd1KzbcwOpbbJ14-x1nLkwPN6wcycqtZf_zI";
	const sheetName = "Carta";

	React.useEffect(() => {
		if (location?.pathname?.includes("/menus/")) {
			// Check location on complete site to prevent API calls outside menu pages
			// console.log("Fetching data");
			FetchData(
				`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}/values/${sheetName}?key=${APIKey}`,
				(data) => setMenuData(data),
				() => setMenuDataError(true),
			);
		}
	}, [location]);

	return (
		<MenuDataContext.Provider
			value={{
				...defaultValues,
				menuData,
				menuDataError,
			}}
		>
			{children}
		</MenuDataContext.Provider>
	);
};
